import React, { Component } from 'react';

import { makeStyles, Theme, useTheme} from '@material-ui/core/styles';
import {createStyles, withStyles } from '@material-ui/core/styles';

import { withRouter } from "react-router-dom";
import update from 'react-addons-update';
import * as jp from 'jsonpath';

// Material components
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionActions';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionActions from '@material-ui/core/AccordionActions';
import Icon from '@material-ui/core/Icon';
import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepContent from '@material-ui/core/StepContent';
import StepLabel from '@material-ui/core/StepLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

// Icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InputIcon from '@material-ui/icons/Input';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LabelOutlinedIcon from '@material-ui/icons/LabelOutlined';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import ShortText from '@material-ui/icons/ShortText';
import EditAttributesOutlinedIcon from '@material-ui/icons/EditAttributesOutlined';
import NoteOutlinedIcon from '@material-ui/icons/NoteOutlined';

//Styled-Components
import styled from 'styled-components';
import { TBContainer, SummaryContainer, DirectionBtnContainer } from '../styles/text_styles.js';
import {NoExt,  StartButton, NextButton, BackButton, ResetButton} from '../styles/app_styles.js';
import {StepWrapper} from '../styles/stepper_styles.js';

//Containers
import TextBody from '../containers/textBody.js';
import PairTable from '../containers/PairTable.js';
import * as RubikMedium from '../fonts/Rubik-Medium.ttf';
import LoadingIndicator from '../containers/loading.js';

//loading indicator promise
import {trackPromise} from 'react-promise-tracker';
import { usePromiseTracker } from "react-promise-tracker";

// sample text for input from TripAdvisor
import {sampleTexts} from '../sampleTexts.js';
import Introduction from '../containers/intro.js';

const DEMO_API = process.env.REACT_APP_API_URL

const styles = theme => ({
  root: {
    [theme.breakpoints.up('lg')]: {
      // width: '80%',
      margin: '0px auto'
    }
  },
  button: {
    margin: '10px'
  },
  startButton: {
    margin: '10px',
    marginLeft: '30px'
  },
  submitButton: {
    verticalAlign: 'bottom',
    margin: '15px'
  },
  stepper: {
    marginTop: '0',
    [theme.breakpoints.down('lg')]:{
      margin: '0px auto',
      width: '80%',
      height: '100%',
      position: 'relative',
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
      margin: '0px auto'
    }
  },
  stepContents: {
    padding: '30px',
    position: 'relative',
    fontFamily: 'Rubik'
  },
  instructions: {
    fontStyle: 'italic',
    marginRight: '10px',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    paddingLeft: '20px',
    color: 'gray'
  },
  contents: {
    margin: '20px',
    fontSize: '16px'
  },
  mappings: {
    marginRight: '50px',
    padding: '10px 30px',
    background: '#F8F8F8',
  },
  headers: {
    paddingLeft: '10px 30px',
  },
  header: {
    margin: '7px 0px',
    fontFamily: 'Rubik'
  },
  actionsContainer: {
    marginBottom: theme.spacing(1),
    width: '700px',
    textAlign: 'right',
    margin: '0px auto',
    marginBottom: '100px',
    paddingRight: '10px',
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  arrowicon: {
    width: 24,
    height: 24,
    verticalAlign: 'text-bottom',
    cursor: 'pointer',
    paddingLeft: '5px',
  },
  arrowdownicon: {
    width: '85%',
    margin: '0 auto',
  },
  paper: {
    margin: '2px 2px',
    padding: '3px 2px',
    background: '#F8F8F8'
  },
  label: {
    fontSize: '1.5em',
    fontFamily: 'Rubik'
  },
  title: {
    fontSize: '1.4em',
    padding: '10px 30px',
  },
  description: {
    fontFamily: 'Rubik',
    fontSize: '1.2em',
    padding: '10px 54px',
    width: '90%',

  },
  field: {
    padding: '8px 0px'
  },
  padding: {
    width: 24,
    height: 46,
  },
  inlineStep: {
    display: 'inline-block',
    padding: '10px 20px',
    verticalAlign: 'top',
  },
  blockStep: {
    display: 'block',
    padding: '40px 20px',
  },
  gridList: {
    margin: '4px 0px',
  },
  inputTextBox: {
    width: 710,
    padding: 8,
    height: '250px'
  },
  inputText: {
    fontSize: '16px',
    fontFamily: 'Rubik',
    lineHeight: 2.5
  },
  heading:{
    fontFamily: 'Rubik',
    fontWeight: 'bold',
    padding: '20px',
    fontSize: '16px'
  }
});

function TextMobileStepper(props) { //change to arrow function for consistency.
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = sampleTexts.length;

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleSelectText = (event, text) => {
    if ( props.handleSelectText )
      props.handleSelectText(text);
  };

  return (
    <div className={classes.root}>
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1c-content"
        id="panel1c-header"
      >
        <div className={classes.column}>
          <Typography className={classes.heading}>Sample Reviews</Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Paper variant="outlined" elevation={0}>
          <Paper elevation={0} className={classes.content}>
            <Typography className={classes.content}>{sampleTexts[activeStep].text}</Typography>
          </Paper>
        <MobileStepper
          steps={maxSteps}
          position="static"
          variant="dots"
          activeStep={activeStep}
          className={classes.stepper}
          nextButton={
            <Button className={classes.nextButton} size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1 || props.parentStep >= 1}>
              Next
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button className={classes.backButton} size="small" onClick={handleBack} disabled={activeStep === 0 || props.parentStep >= 1}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button>
          }
        />
        </Paper>
      </AccordionDetails>
      <AccordionActions>
        <Button className={classes.selectButton} disabled={props.parentStep >= 1} size="small" onClick={(event) => handleSelectText(event, sampleTexts[activeStep].text)}>Select</Button>
      </AccordionActions>
    </Accordion>
    </div>
  );
}

// TextMobileStepper (carousel text menu ) styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '80vw',
      flexGrow: 1,
      padding: '20px 10px'
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      height: 50,
      paddingLeft: theme.spacing(4),
      backgroundColor: "#e0e0e0",
      position: 'relative'
    },
    content: {
      height: 140,
      maxWidth: 680,
      overflow: 'auto',
      display: 'block',
      width: '100%',
      padding: 6,
      backgroundColor: theme.palette.background.default,
      fontFamily: 'Rubik'
    },
    stepper: {

    },
    selectButton: {
      margin: 'auto',
      width: '15%',
      background: 'linear-gradient( rgba(24,112,57,0.86), rgba(162,210,81,0.83))',
      color: '#ffffff',
      fontWeight: 'bold'
    },
    backButton: {
      position: 'absolute',
      left: '10px',
      bottom: '10px',
    },
    nextButton: {
      position: 'absolute',
      right: '10px',
      bottom: '10px',
    },
    dots: {
      backgroundColor: 'red',
    }
  }),
);

class APIStepper extends Component {

  constructor(props) {
    super(props);
    this.state = {
      steps: [],
      status: '',
      activeStep: -1,
      nextActive: true,
      backActive: false
    }
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleBackStep = this.handleBackStep.bind(this);
    this.handleResetSteps = this.handleResetSteps.bind(this);

    this.handleTaskDataChange = this.handleTaskDataChange.bind(this);
  }

  componentDidMount() {
    this.initializeSteps();
  }

  static getDerivedStateFromProps(props, state) {

    if ( props.params ) {

      for ( let param in props.params) {

        let value = props.params[param];

        if ( value !== state[param] ) {
          return({
            [param]: value});
        }
      }
    }
    return null
  }

  initializeSteps() {

    let taskSpec = {
      steps: [
        {
          id: 0,
          isActive: () => { return this.state.activeStep >= 0 },
          title: 'Enter Review Text',
          icony: <InputIcon/>,
          instructions: 'Enter input text below, or select from example text provided.',
          data: [{attribute: 'selectedText', defaultValue: ''}]

        },
        {
          id: 1,
          isActive: () => { return this.state.activeStep >= 1 },
          title: 'Extract Aspects & Opinions',

          icony: <LabelOutlinedIcon/>,
          instructions:"",
          data: [{attribute: 'extract', api:'/snippext', method: 'POST', form: { data: this.state.selectedText }}]
        },
        {
          id: 2,
          isActive: () => { return this.state.activeStep >= 2 },
          title: 'Pair Aspects & Opinions',
          icony: <LabelOutlinedIcon/>,
          data: [{attribute: 'pair', defaultValue: 'pairing'}]

        },
        {
          id: 3,
          isActive: ()=> { return this.state.activeStep >= 3 },
          title: 'Sentiment Analysis of Opinions',
          icony: <SentimentSatisfiedIcon />,
          data:[{attribute: 'sentiment', defaultValue: 'sentiment'}]

        }
      ]
    }

    this.setState({'steps': taskSpec.steps});
  }

// step content based on step number by ndx
  getStepContent(id) {
    const CHARACTER_LIMIT = 600;
    let selected = !this.state.selectedText ? '' : this.state.selectedText
    const { classes } = this.props;
      switch (id) {
        case 0: //sample text or text input. take it and pass it to
          return (
                <div className={classes.inlineStep}>
                    <TextMobileStepper parentStep = {this.state.activeStep} handleSelectText={(text) => this.setState({selectedText: text})}/>
                    <Typography className="summaryText" > </Typography>
                      <TextField multiline rows="5" className={classes.inputTextBox}
                        onChange={(e) => this.handleTaskDataChange(e, 'selectedText')}
                        InputLabelProps={{ shrink: true }}
                        label="Review text" margin="normal" variant="outlined"
                        inputProps={{
                          maxLength: CHARACTER_LIMIT,
                          className: classes.inputText,
                        }}
                        value={this.state.selectedText}
                        helperText={`${selected.length}/${CHARACTER_LIMIT}`}
                      />
                 </div>
               )
        case 1:
          if (this.state.data && this.state.data.extractions.length === 0) {
           return (<NoExt> Oops, something went wrong. Please try another review. </NoExt>)
           } else if(this.state.data){
              return (
                  <div className={classes.inlineStep}>
                    <TBContainer>
                      <TextBody
                      data={this.state.data}
                      step={id}
                      />
                    </TBContainer>
                  </div>
                )
            } else {
              return <LoadingIndicator />
            }

        case 2:
          return(
            <div className={classes.inlineStep}>
              <TBContainer>
                <PairTable data={this.state.data} step={id} />
              </TBContainer>
            </div>
          )

        case 3:
        // sentiment color coded opinion
          return(
              <div className={classes.inlineStep}>
                <TBContainer>
                  <TextBody
                  data={this.state.data}
                  step={id}
                  />
                </TBContainer>
              </div>
            )
      default:
        return 'Unknown step';
      }

    }

  resetSteps() {
    this.resetTaskData();
  }

  resetTaskData() {
    for ( let i in this.state.steps ) {
        this.resetStepData(this.state.steps[i]);
    }
  }

  resetStepData(step) {
    let data = step.data;
    for ( let i in data ) {
      let d = data[i];
      if ( d.api ) {
        this.setTaskData(d.attribute, []);
      }
      else {
        this.setTaskData(d.attribute, d.defaultValue);
      }
    }
  }

  async fetchExtract(attribute, text, api){

    if(!text || text === ''){
      return
    }
    var formData = new FormData();
    formData.append('data', text);
    var isFormDataEmpty= true;
    for (var p of formData) {
     isFormDataEmpty= false;
     break;
   }


  await trackPromise(
   fetch(DEMO_API,
      {
      method: 'POST',
      body: formData
    })
    .then(response=> response.json())
    .then((data) => {
      if(data.extractions.length === 0){
        this.setState({
          nextActive: false,
          "data": data
        })
      }
      this.setState({
        "data": data
      })
    })
    .catch(error => console.error("Error:", error))
    );
  }

  initializeStepData(step) {
    let data = step.data;
    for ( let i in data ) {
      let d = data[i];
      if ( d.api ) {
        this.fetchExtract(d.attribute, this.state.selectedText, d.api)
      }
      else {
        if ( !this.hasTaskData(d.attribute) )
          this.setTaskData( d.defaultValue);
      }
    }
  }

  getTaskData(attribute) {
    return this.state[attribute];
  }

  hasTaskData(attribute) {
    return attribute in this.state;
  }

  setTaskData(attribute, value, index) {
    if ( index ) {
      const array_value = update(this.state[attribute], {$splice: [[index-1, 1, value]]});
      this.setState({[attribute]: array_value});
    }
    else {
      this.setState({[attribute]: value});
    }
  }

  handleTaskDataChange(event, attribute, index) {
    console.log(event, attribute, index)
    let value = event.target.value;
    this.setTaskData(attribute, value, index);
  }

  buildAPIURL(api) {
    return this.substitutePropsState(process.env.REACT_APP_API_SERVER );
  }

  substitutePropsState(text) {
    //cleaning text
    let re = /<([^>^:]+)(:([^>]+))?>/g;

    let mt = 'string';

    let mts = text.replace(re, (m) => {

        m = m.substr(1, m.length-2);

        let mci = m.indexOf(":");
        if ( mci > 0 ) {
          mt = m.substring(mci+1);
          m = m.substring(0,mci);

        }
        let ma = m.split('.');

        let v = {};
        for ( let i = 0; i < ma.length; i++ ) {
          let mai = ma[i];
          if ( i === 0 ) {
            if ( mai === 'props' ) {
                v = this.props;
              }
            else if ( mai === 'state' ) {
                v = this.state;
              }
            else {
                return '';
            }
          }
          else {
            v = v[mai]
          }
        }

        return v;
    });

    if ( mt === 'number' )
      return Number(mts);
    else
      return mts;
  }

  substitutePropsStateRecursively(obj) {
    if ( typeof(obj) == 'string' ) {
      return this.substitutePropsState(obj);
    }
    else if ( typeof(obj)== 'object' ) {
      if ( Array.isArray(obj) ) {
        return obj.map((d,i) => this.substitutePropsStateRecursively(d));
      }
      else {
        for ( let key in obj ) {
          obj[key] = this.substitutePropsStateRecursively(obj[key])
        }
        return obj;
      }
    }
    else
      return obj;
  }

  handleNextStep() {
    if(this.state.activeStep === 0){
      if(!this.state.selectedText || this.state.selectedText.length === 0){
        window.alert("Add a review from the samples or enter your own text.")
        return
      }
    }
    let activeStep = this.state.activeStep + 1;
    let backActivated = activeStep >= 1 ? true : false
    this.setState({
      'activeStep': activeStep,
      backActive: backActivated
    });

    this.initializeStepData(this.state.steps[activeStep]);
  };

  handleBackStep() {
    let states={}
    let activeStep = this.state.activeStep
    let data = this.state.data
    if(this.state.activeStep >= 1) {
      activeStep = activeStep - 1;
    }

    if(this.state.data.extractions.length === 0 && activeStep <= 1){
        states['activeStep'] = activeStep
        states['nextActive'] = true
      } else {
        states['activeStep']= activeStep
    }

    if(activeStep < 1 && data.extractions){
      data = {'extractions': []}
      states['data'] = data
      states['backActive'] = false
    }

    console.log("states", states)
    this.setState(
      states
    )
  };

  handleResetSteps() {
    this.resetSteps();
    this.setState({'activeStep': 0, 'backActive': false });
  };

  render() {
    const { classes } = this.props;
    const stepContents = [];

    for ( let i = 0; i <= this.state.activeStep; i++ ) {
      stepContents.push(this.getStepContent(i));
    }

    return (
      <div>
        <Paper square elevation={1} className={classes.stepper}>
          <Divider />
          <Introduction
          activeStep={this.state.activeStep}
          handleNext={this.handleNextStep}
          />
          <StepWrapper>
            <Stepper activeStep={this.state.activeStep}  orientation="vertical">
                {this.state.steps.map((step, index) => (
                  <Step key={step.id} active={step.isActive()}>
                    <StepLabel StepIconComponent={() => <Icon>{step.icony}</Icon>}>
                      <Typography variant="body1" variantMapping={{'body1': 'span'}} className={classes.label} color="textPrimary" >{step.title}</Typography>
                    </StepLabel>
                    <StepContent>
                      <Typography variant="body2"
                       className={classes.instructions}>
                      {step.instructions}
                      </Typography>
                      {this.getStepContent(step.id)}
                      {
                        this.state.activeStep === step.id && this.state.activeStep < this.state.steps.length - 1 && (
                            <div className={classes.actionsContainer}>
                              <BackButton
                                backActive={this.state.backActive}
                                disabled={this.state.activeStep <= 1}
                                onClick={this.handleBackStep}
                              >
                                Back
                              </BackButton>
                              <NextButton
                                nextActive={this.state.nextActive}
                                variant="contained"
                                onClick={this.handleNextStep}
                              >
                                Next
                              </NextButton>
                          </div>
                        )
                      }
                      {
                        this.state.activeStep === step.id && this.state.activeStep === this.state.steps.length  - 1 && (
                          <div  className={classes.actionsContainer}>
                            <div>
                              <ResetButton
                                onClick={this.handleResetSteps}>
                                Reset
                              </ResetButton>
                            </div>
                          </div>
                        )
                      }
                    </StepContent>
                  </Step>
                    ))}
            </Stepper>
          </StepWrapper>
        </Paper>
    </div>
  )

  }
}

export default withRouter(withStyles(styles)(APIStepper))
